export const environment = {
  production: true,
  apiUrl: 'https://proto-api1.ibercon.org',
  appVersion: '2.1.0',

  disableUsers: false,
};
